import loadScriptBrowser from './load-script-browser';

export default loadScriptBrowser;
